import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { SingleCreationForDetailFragment } from '../../../../graphql/generated/graphql';
import PublicId from '../../../component/primitive/PublicId';

type Props = {
  creation: Pick<SingleCreationForDetailFragment, 'id' | 'creativeFormat'>;
  className?: string;
};

const CreationsCardHeader: FC<Props> = ({ creation, className }) => {
  const { network, placement, attribute } = creation.creativeFormat;
  const networkAndPlacementMessage = `${network.name} ${placement.name}`;
  const playbackTimeMessage = attribute.playbackTime ? (
    <FormattedMessage id="creative_format.playback_time" values={{ seconds: attribute.playbackTime.seconds }} />
  ) : null;
  const aspectRatioMessage = attribute.aspectRatio
    ? attribute.aspectRatio.aspectRatio.width === 0 &&
      attribute.aspectRatio.aspectRatio.height === 0 &&
      attribute.aspectRatio.size.width === 0 &&
      attribute.aspectRatio.size.height === 0
      ? null
      : `${attribute.aspectRatio.aspectRatio.width}:${attribute.aspectRatio.aspectRatio.height}`
    : null;

  return (
    <Root className={className}>
      <CreativeFormat color="textSecondary" noWrap>
        {networkAndPlacementMessage} {aspectRatioMessage} {playbackTimeMessage}
      </CreativeFormat>
      <Typography>
        <PublicId id={creation.id} color="textSecondary" />
      </Typography>
    </Root>
  );
};

const Root = styled('div')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const CreativeFormat = styled(Typography)({
  fontSize: 18,
});

export default CreationsCardHeader;
